import moment from "moment";

export const getDeliveryDateData = (preOrderStart, preOrderEnd, isInAsap) => {
  let dateData = [];
  let start = moment().add(parseInt(preOrderStart), "hours");
  let end = moment().add(parseInt(preOrderEnd), "hours");
  const minute = start.minute();

  let addedHours, addedMinute;
  if (isInAsap) {
    dateData.push("ASAP");
  }

  if (0 <= minute && minute < 15) {
    addedMinute = 15 - minute;
    addedHours = 0;
  } else if (15 <= minute && minute < 30) {
    addedMinute = 30 - minute;
    addedHours = 0;
  } else if (30 <= minute && minute < 45) {
    addedMinute = 45 - minute;
    addedHours = 0;
  } else {
    addedMinute = 60 - minute;
    addedHours = 1;
  }
  start = start.add(addedMinute, "minutes").add(addedHours, "hours");
  for (let i = 1; i < 30; i++) {
    dateData.push(start.format("HH:mm"));
    if (end.valueOf() < start.valueOf()) {
      break;
    } else {
      start = start.add(15, "minutes");
    }
  }
  return dateData;
};
